<mat-toolbar>
  @if (authService.isLoggedIn) {
    <button type="button" mat-icon-button disableRipple class="mobile-visible burger" (click)="sidenav.toggle()" aria-label="Open navigation">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <a class="logo" [routerLink]="['/']">
    @if (testEnv) {
      <span class="env">{{ testEnv }}</span>
    }
  </a>

  <app-canary></app-canary>

  <span class="logo-gap"></span>

  @if (selection && selection.company && selection.site) {
    <a
      class="desktop-visible supplychains_top_nav_btn"
      data-tour="risk-radar-nav"
      [routerLink]="['/company', selection.company.id, 'site', selection.site.id]"
      mat-raised-button
      [color]="mode === AppMode.EUDR_RISK ? 'primary' : undefined"
    >
      {{ 'supply_chains_tr' | translate }}
    </a>
    @if (!isFeatureHidden('eudr')) {
      <a
        class="desktop-visible eudr_traces_top_nav_btn"
        data-tour="traces-nav"
        [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'traces-eudr']"
        mat-raised-button
        [color]="mode === AppMode.EUDR_TRACES ? 'primary' : undefined"
      >
        {{ 'EUDR_Traces_tr' | translate }}
        @if (isFeatureDisabled('eudr')) {
          <mat-icon>arrow_circle_up</mat-icon>
        }
      </a>
    }
    @if (!isFeatureHidden('ppwr')) {
      <a
        class="desktop-visible ppwr_top_nav_btn"
        data-tour="ppwr-nav"
        [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'ppwr']"
        mat-raised-button
        [color]="mode === AppMode.PPWR ? 'primary' : undefined"
      >
        {{ 'PPWR_tr' | translate }}
        @if (isFeatureDisabled('ppwr')) {
          <mat-icon>arrow_circle_up</mat-icon>
        }
      </a>
    }
  }

  <span class="toolbar-item-spacer"></span>

  @if (authService.authReady$ | async) {
    @if (!authService.isLoggedIn || showE2eLanguageSwitcher) {
      <app-language-select
        appearance="fill"
        data-e2e-screenshot-language-switcher
      ></app-language-select>
    }

    @if (authService.user$ | async; as user) {
      @if (companies) {
        @if (companies.length > 0 && selection?.company && selection?.site) {
          <div [matMenuTriggerFor]="companyMenu" [title]="selectionTitle" class="menu company-selector">
            <span class="company-site-label">
              <span class="cs-company">{{ selection?.company?.name }}</span>
              @if (selectionSiteShown) {
                <span class="cs-site">&nbsp;- {{ selection?.site?.name }}</span>
              }
            </span>
          </div>

          <mat-menu #companyMenu class="company-selector-menu" yPosition="below">
            @for (company of companies; track company) {
              @for (site of company.sites; track site) {
                <button
                  type="button"
                  (click)="preselectCompanySite(company, site)"
                  [routerLink]="switchCompany(company, site)"
                  [title]="company.name + ' - ' + site.name"
                  mat-menu-item
                >
                  <span class="company-site-label">
                    <span class="cs-company">{{ company.name }}</span>
                    @if (siteShown(company, site)) {
                      <span class="cs-site">&nbsp;- {{ site.name }}</span>
                    }
                  </span>
                </button>
              }
            }
          </mat-menu>
        }

        <div data-tour="nav-manage" style="display: flex; align-items: center; gap: 8px">
          <button
            type="button"
            (click)="openHelp()"
            [matTooltip]="'Help_Center_tr' | translate"
            [attr.aria-label]="'Help_Center_tr' | translate"
            [matTooltipDisabled]="!isCompact()"
            mat-flat-button
            color="accent"
            class="help-btn"
            data-testid="top-nav-help-center"
          >
            <mat-icon>help</mat-icon>
            <span class="desktop-visible help-label">{{ 'Help_Center_tr' | translate }}</span>
          </button>
        </div>
      }
    }
  }
</mat-toolbar>
